import Produit from "./Produit";

export default class ProduitNumerique extends Produit {

  constructor(code, libelle, audienceBase, tarifBase) {
    super(code, libelle, 'ODV', [100], []);
    this.audienceBase = audienceBase;
    this.tarifBase = tarifBase;
  }

  tarif(semaine) {

    // Le tarif des produits numériques est directement indexé par le coefficient d'audience de la semaine.
    const coefTarif = semaine.coefAudience;
    const tarif = this.tarifBase[semaine.codeAudienceTarif] * coefTarif;

    return tarif.roundN(5);
  }

  audience(semaine) {

    const coefAudience = semaine.coefAudience;
    const audience = this.audienceBase[semaine.codeAudienceTarif] * coefAudience;

    return audience.roundN(1);
  }
}
